import React from 'react';
import './ProfileView.less';
import ProfileForm from '../../user/ProfileForm/ProfileForm.jsx';
import {Row, Item, Column} from 'react-plan';
import { observer } from 'mobx-react';

type Props = {

}

@observer(['user'])
class ProfileView extends React.Component {

  description: 'The view where users can edit their profile.'

  props: Props

  constructor(props: Props) {
    super(props);
    this.store = this.props.user;
    this.fileReader = new FileReader();
    this.fileReaderListener = this.fileReader.addEventListener('load', () => {
      this.store.uploadAvatar(this.fileReader.result);
    });
  }



  /* Component Custom Methods */
  handleFileChange = (evt) => {
    const file = evt.target.files[0];
    if (file) {
      this.fileReader.readAsDataURL(file);
    }
  }
  /* End Component Custom Methods */

  /* React Component LifeCycle Methods */
  //componentWillMount() {}
  //componentDidMount() {}
  //componentWillReceiveProps(nextProps) {}
  //shouldComponentUpdate(nextProps, nextState) {}
  //componentWillUpdate(nextProps, nextState) {}
  //componentDidUpdate(prevProps, prevState) {}
  //componentWillUnmount() {}
  render() {
    const avatar = this.store.profile.avatar || require('../../../img-layout/img-profil.jpg');
    return (
      <div className="profile-view">
        <div className="profil bloc-xs">
          <h2 className="txt-center m-b-xl">Account Information</h2>
          <Row justify="center">

            <Item size="30%" small="37%" align="center">
              <label htmlFor="file-input">
                <img alt="uploader" className="uploader" src={ avatar } />
                <img alt="add" className="add" src={ require('../../../img-layout/add.png') } />
              </label>
              <input id="file-input" type="file" onChange={ this.handleFileChange } />
            </Item>
          </Row>
          <h3 className="txt-center">{ this.props.user.name }</h3>
          <ProfileForm />
        </div>
      </div>
    );
  }
  /* End React Component LifeCycle Methods */
}

export default ProfileView;

//Unit test entry point
export const ProfileViewTest = ProfileView;


/** WEBPACK FOOTER **
 ** ./src/js/views/ProfileView/ProfileView.jsx
 **/